import { computed } from 'vue';
import { rolesArray } from '@/refs/common.refs';

/**
 * Approximation client d'un rôle système : le serveur exige en plus l'absence
 * de scope organisation/store (PaymentPolicies.manageReconciliation), une
 * condition non représentable ici puisque rolesArray ne porte pas le scope.
 * Sert uniquement à masquer l'UI ; le serveur reste la seule vraie barrière.
 */
export function useIsSystemAdmin() {
  const isSystemAdmin = computed(() =>
    ((rolesArray.value ?? []) as string[]).includes('admin_system'),
  );
  return { isSystemAdmin };
}
